import { getColor } from 'common/constants/_colors';
import styled, { css } from 'styled-components';

export const StyledTooltip = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  border: 1px solid ${getColor('botticelli')};
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${getColor('shuttleGray')};
  ${({ flex }) =>
    flex &&
    css`
      flex: ${flex};
    `};
`;
export const StyledColumnItem = styled.div`
  ${({ header }) =>
    header &&
    css`
      background-color: ${getColor('catskillGray')};
      font-weight: bold;
      color: ${getColor('shark')};
    `};
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  width: 100%;
  box-sizing: border-box;
`;
